import { EventCategory } from "@/types/events";
import { Activity, BrickWall, CloudRainWind, Droplets, Flame, FlaskConical, Layers, TrendingDown, WavesHorizontal, Wind, } from "lucide-react";
export const INCIDENT_CATEGORIES = [
    {
        category: EventCategory.CHUVAS,
        icon: CloudRainWind,
        label: "Chuvas",
        to: "/criar/chuvas",
    },
    {
        category: EventCategory.AREA_ALAGAMENTO,
        icon: WavesHorizontal,
        label: "Áreas de Alagamento",
        to: "/criar/area-alagamento",
    },
    {
        category: EventCategory.NIVEL_RIOS,
        icon: Droplets,
        label: "Nível do Rio",
        to: "/criar/nivel-rios",
    },
    {
        category: EventCategory.BARRAGENS,
        icon: BrickWall,
        label: "Barragens",
        to: "/criar/barragens",
    },
    {
        category: EventCategory.VENDAVAL,
        icon: Wind,
        label: "Vendaval",
        to: "/criar/vendaval",
    },
    {
        category: EventCategory.INCENDIO,
        icon: Flame,
        label: "Incêndios",
        to: "/criar/incendio",
    },
    {
        category: EventCategory.TREMOR,
        icon: Activity,
        label: "Tremor de Terra",
        to: "/criar/tremor",
    },
    {
        category: EventCategory.DESLIZAMENTO,
        icon: TrendingDown,
        label: "Deslizamento",
        to: "/criar/deslizamento",
    },
    {
        category: EventCategory.PERDA_SOLO,
        icon: Layers,
        label: "Perda de Solo",
        to: "/criar/perda-solo",
    },
    {
        category: EventCategory.PRODUTOS_QUIMICOS,
        icon: FlaskConical,
        label: "Produtos Químicos",
        to: "/criar/produtos-quimicos",
    },
];
